import { AmountUsd } from '@ui/components/Amount/AmountUsd';

import { useFromInput } from '../../hooks/useFromInput';
import { usePositionSize } from './hooks/usePositionSize';

export const PositionSize = () => {
  const inputUsd = useFromInput((s) => s.input).value.usd; // fromUsd
  const positionSize = usePositionSize({ inputUsd });

  return (
    <AmountUsd
      textStyle="text.small"
      value={positionSize}
      defaultUndefinedDisplay="Not Set"
      opts={{ prefix: '~$' }}
      data-cy="PositionSizeUsd"
      data-cy-value={positionSize}
    />
  );
};
